import { render, staticRenderFns } from "./Philosophy.vue?vue&type=template&id=ca210a0c&"
import script from "./Philosophy.vue?vue&type=script&lang=js&"
export * from "./Philosophy.vue?vue&type=script&lang=js&"
import style0 from "./Philosophy.vue?vue&type=style&index=0&id=ca210a0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports